import { useEffect, useState, useRef } from "react";
import { Form, useActionData, useLoaderData } from "react-router-dom";
import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";
import { Button, Stack, styled, TextField, MenuItem } from "@mui/material";
import PageTitle from "../ui/PageTitle";
import FormHeader from "../ui/FormHeader";

const CHARACTER_LIMIT_SHORT = 500;
const CHARACTER_LIMIT_LONG = 1500;

const StyledStack = styled(Stack)`
  height: 100%;
  width: 100%;
  padding-top: 3em;
`;

const Edit = () => {
  const snackbarInfo = useInfoSnackbar(2000, "bottom", "right");
  const formRef = useRef();

  const actionData = useActionData();
  const loaderData = useLoaderData();
  const conversations = loaderData.conversations || [];

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        snackbarInfo.alertSuccess(actionData.message);
        formRef.current.reset();
        setFormData({
          shortDescription: "",
          longDescription: "",
        });
      } else {
        snackbarInfo.alertError(actionData.message);
      }
    }
  }, [actionData]);

  const [formData, setFormData] = useState({
    shortDescription: "",
    longDescription: "",
  });

  const handleChange = (name) => (event) => {
    const { value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Update Conversations"
            breadcrumb={[
              { name: "home", path: "/" },
              {
                name: "Conversations",
                path: "/conversation",
              },
              {
                name: "Update",
                path: "/conversation/edit",
              },
            ]}
          />
        </div>

        <div className="flex items-center justify-center">
          <div className="w-[600px] bg-white p-10 border-solid border-2 mt-8">
            <FormHeader title="Update a Conversation" />
            <StyledStack>
              <Form method="post" ref={formRef}>
                <Stack
                  direction={"column"}
                  justifyContent={"space-between"}
                  spacing={2}
                  mb={2}
                >
                  <TextField
                    id="conversationEntityId"
                    name="conversationEntityId"
                    label="Select a Conversation Type to Update"
                    fullWidth
                    select
                    required
                  >
                    {conversations.map((conversation) => (
                      <MenuItem
                        key={conversation.conversationEntityId}
                        value={conversation.conversationEntityId}
                      >
                        {conversation.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    type="text"
                    id="label"
                    name="label"
                    label={"Label"}
                    fullWidth
                    required={true}
                  />
                  <TextField
                    type="text"
                    id="name"
                    name="name"
                    label={"Name"}
                    fullWidth
                    required={true}
                  />
                  <TextField
                    type="text"
                    id="shortDescription"
                    name="shortDescription"
                    label={"Short Description"}
                    fullWidth
                    multiline
                    rows={2}
                    inputProps={{
                      maxLength: CHARACTER_LIMIT_SHORT,
                    }}
                    value={formData.shortDescription}
                    helperText={`${formData.shortDescription.length}/${CHARACTER_LIMIT_SHORT}`}
                    onChange={handleChange("shortDescription")}
                  />
                  <TextField
                    type="text"
                    id="longDescription"
                    name="longDescription"
                    label={"Long Description"}
                    fullWidth
                    multiline
                    rows={4}
                    inputProps={{
                      maxLength: CHARACTER_LIMIT_LONG,
                    }}
                    value={formData.longDescription}
                    helperText={`${formData.longDescription.length}/${CHARACTER_LIMIT_LONG}`}
                    onChange={handleChange("longDescription")}
                  />
                </Stack>
                <Stack mt={2}>
                  <Button
                    type={"submit"}
                    variant={"outlined"}
                    sx={{
                      color: "#1e3faf",
                      borderRadius: "9999px",
                      borderColor: "#60a5fa",
                      "&:hover": {
                        backgroundColor: "#dbeafe",
                      },
                    }}
                  >
                    Update
                  </Button>
                </Stack>
              </Form>
            </StyledStack>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
